import { useCallback, useEffect, useState, useRef } from 'react';
import { ROUTE_SECURITY_DOCUMENTS, ROUTE_BASIC_SECURITY_REPORT, ROUTE_WELCOME } from '../../routes/Routes';
import { useNavigate } from "react-router-dom";
import usePageTitle from '../../hooks/usePageTitle';
import GetFetch from '../../hooks/GetFetch';
import { LoadingPanel } from "../../components/LoadingPanel";
import GetFetchZip from '../../hooks/GetFetchZip';
import { Button, SelectBox } from "devextreme-react";
import DataGrid, {
    Column,
    Format,
    Item,
    KeyboardNavigation,
    Pager,
    Paging,
    SearchPanel,
    Grouping,
    Toolbar
} from 'devextreme-react/data-grid';
import CustomPreparedHeaderCell from '../../components/CustomPreparedHeaderCell';
import { allowedPageSizes, pageFormats } from '../../components/GlobalDataGridConfigurations';
import { logExport, useAuth } from '../../hooks/useAuth';
import ExportGrid from '../../components/ExportGrid';
import '../BasicSecurityInformation/ListInformation.scss';


const BasicSecurityDocuments = () => {
    const { title } = ROUTE_SECURITY_DOCUMENTS;
    const { user } = useAuth();
    const email = user.email.toString().toLowerCase();
    const navigate = useNavigate();
    const navigateToHomePage = () => navigate(ROUTE_WELCOME.withSlash);
    const dataGridRef = useRef(null);
    const [allowCreate, setAllowCreate] = useState(true);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    
    useEffect(() => { 
        getBasicSecurityDocuments(); 
    }, []);
    usePageTitle( title );

    const getBasicSecurityDocuments = async () => {
        setLoading(true);
        try {
            const { Success, Message, Errors } = await GetFetch(`/v1/BasicSecurity/Templates`);
            if (Success)
                setDataSource(Message.map(item => item));

            if (Errors.length > 0)
                console.error(Errors);
        } 
        catch (error) 
        {
            console.error('Error: ', error);
        }
        setLoading(false);
    };

    const fetchBasicSecurityDocuments = async () => {
        setLoading(true);
        const data = await GetFetch(`/v1/BasicSecurity/Templates`);
        const { Success, Message, Errors } = data;
        setError(Success === false);
        
        if (Success) {
            setDataSource(Message);
        }
        if (Errors?.length > 0) {
            setErrorMessage(Errors[0].Message)
            console.log(Errors)
        }
        setLoading(false);
    };
    
    const GroupCell = options => <div>{options.caption}</div>;
    const onBackClick = () => {
        navigateToHomePage();
    };

    const handleExport = (e) => {
        logExport(user.email)
        ExportGrid(e, title, true, 12)
    };

    return (
        <>
            <div className="inline__div--wrapper">
                <h1> { title } </h1>
            </div>
            {allowCreate &&
                <Button
                    stylingMode="contained"
                    text="Add Basic Security Template"
                    width={275}
                    onClick={() => navigate(ROUTE_BASIC_SECURITY_REPORT.withSlash)}
                    id="add_basic_security_document"
                />
            }
            {loading && <LoadingPanel location={{ of: '#bsa-docs' }} message="Loading Basic Security Templates..." />}
            {
                !loading &&
                <div id='bsa-docs' className="inline__div--wrapper">
                    <DataGrid 
                        columnAutoWidth={true}
                        dataSource={dataSource}
                        ref={dataGridRef}
                        onCellPrepared={CustomPreparedHeaderCell}
                        onExporting={e => handleExport(e)}
                        rowAlternationEnabled={true}
                        showBorders={true}
                        showColumnLines={true}
                        showRowLines={true}
                        export={{enabled: true, formats: pageFormats}}
                        key="Id"
                        >
                        <Toolbar>
                            <Item
                                location="after"
                                name="searchPanel"
                                locateInMenu="auto"
                            />
                            <Item
                                location='after'
                                name="exportButton"
                                enabled={true}
                                formats={pageFormats}
                            />
                        </Toolbar>
                        <Column 
                            dataField="Id"
                            visible={true}
                            alignment='left'
                        />
                        <Column 
                            caption='Fiscal Year'
                            dataField='FiscalYear'
                            groupIndex={0}
                        />                        
                        <Column 
                            caption='File Type'
                            dataField='FileType'
                        />
                            <Column
                                caption='Created By'
                                dataField='CreatedBy'
                            />
                            <Column
                                caption='Created Date'
                                dataField='CreatedDate'
                            />
                            <Column
                                caption='Updated By'
                                dataField='UpdatedBy'
                            />
                            <Column
                                caption='Updated Date'
                                dataField='UpdatedDate'
                            />
{/*                         <Column 
                            dataField="Id"
                            name="Edit" 
                            caption=""
                            hint="Assessment Letter" 
                            width={50} 
                            cellRender={(e) => renderAssessmentLetterButton(e)} 
                            // groupCellRender={GroupCell}
                        /> */}
                        <KeyboardNavigation enabled={true} />
                        <Grouping autoExpandAll={false} />                        
                        <SearchPanel 
                            highlightCaseSensitive={true}
                            visible={true}
                        />
                        <Pager 
                            allowedPageSizes={allowedPageSizes}
                            showPageSizeSelector={true}
                        />
                        <Paging 
                            defaultPageSize={10}
                        />
                    </DataGrid>
                </div>
            }
        </>
    )
};

export default BasicSecurityDocuments;